import { TrainingStatus } from "@enums/trainingStatus.enum";
import { Model } from "@interfaces/model.interface";

export interface Training extends Model {
	expiryDate: Date;
	level: number;
	skillId: number;
	trainingDate: Date;
	trainingStatus: TrainingStatus;
	userProfileId: number;
	userProfileName: string;
}

export class Training implements Training {
	level = 0
	trainingDate = new Date();

	constructor(data?: Partial<Training>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}